import { IntercomProps } from "react-use-intercom";
import { CustomBranding } from "@utils/custom-branding/CustomBranding";
import { LocalData } from "to-be-removed/LocalData/General/LocalData";

export class IntercomHelper {
  static INTERCOM_ID = "cntlwgh0";

  static getProps(identityVerificationToken?: string): IntercomProps {
    return {
      backgroundColor: CustomBranding.primaryColor,
      actionColor: CustomBranding.buttonColor,
      userId: LocalData.currentUser.id,
      userHash: identityVerificationToken,
      name: LocalData.currentUser.name,
      email: LocalData.currentUser.email,
      phone: LocalData.currentUser.phone,
      createdAt: LocalData.currentUser.createdBy?.date?.toISOString(),
      companies: LocalData.currentUser.companies.map((company) => ({
        companyId: company.id,
        name: company.name,
        createdAt: company.createdBy?.date?.toISOString(),
      })),
      customAttributes: {
        "Role Landlord": LocalData.currentUser.checkForLandlordRoles(),
        "Role Tenant": LocalData.currentUser.checkForTenantRoles(),
        "Role Contractor": LocalData.currentUser.contractorGroups.length > 0,
      },
    };
  }
}
